<template>
    <div @click.stop>
        <vx-card no-shadow title="Nova requisição de acesso">
            <div class="vx-row">
                <div class="vx-col" id="avatar-col">
                    <div class="img-container mb-8">
                        <vs-avatar :text="nameScaped" :src="requester.photoUrl"  size="70px" />
                    </div>
                </div>
                <div class="vx-col flex-1" id="account-info-col-1">
                    <table>
                    <tr>
                        <td class="increase-text font-semibold">Nome: </td>
                        <td class="increase-text ">{{ requester.name }}</td>
                    </tr>
                    <tr>
                        <td class="increase-text font-semibold">Email: </td>
                        <td class="increase-text ">{{ requester.email }}</td>
                    </tr>
                    </table>
                </div>
            </div>

            <div class="w-full text-center mb-2">
                <a-radio-group v-model="selection"
                    size="large" button-style="solid" style="margin: 0 auto">
                    
                    <a-radio-button :value="role.id" v-for="role in roles" :key="role.id">
                        <component :is="role.icon" :size="28" class="icon-fix" />
                        <span class="label-fix">{{ role.description }}</span>
                    </a-radio-button>

                </a-radio-group>
                <div class="mt-4 mb-4" style="height: 45px" v-html="roles.find(r => r.id == selection).obs"></div>
            </div>
        </vx-card>

        <div class="flex">
            <a-button :loading="busy" class="w-full mr-1" size="large" type="danger" @click="approve">APROVAR</a-button>
            <a-button :loading="busy" class="w-full mr-1" size="large" @click="reprove">REJEITAR</a-button>
            <!-- <vs-button disabled loading class="w-full mr-1" color="success" @click="approve">APROVAR</vs-button> -->
            <!-- <vs-button class="w-full ml-1" @click="reprove">REJEITAR</vs-button> -->
        </div>
    </div>
</template>

<script>
    import firebase from '@/firebase/firebase';
    import util from '@/assets/utils/misc';
    import { associateUserToCompany } from '@/user';

    export default {
        props: {
            value: String,
            inviteId: String,
            requester: Object
        },
        data() {
            return {
                busy: false,
                roles: [
                    { id: '2', description: 'Atendente', icon: 'account', obs: 'Poderá lançar pedidos e juntar mesas' },
                    { id: '1', description: 'Gestor', icon: 'account-tie', obs: 'Pode cancelar e editar pedidos confirmados, além de fechar contas.' },
                    { id: '0', description: 'Administrador', icon: 'shield-account', obs: 'Pode ver os relatórios do estabelecimento, além de aprovar novos usuários. <br/><p class="mb-2"><b>CUIDADO!</b> Este perfil possui todos os acessos ao sistema.</p>' }
                ],
            }
        },
        computed: {
            selection: {
                get () {
                    return this.value || 2;
                },
                set (v) {
                    this.$emit('input', v);
                }
            },
            nameScaped () {
                return util.removeSpecialChars(this.requester.name || '');
            },
        },
        methods: {
            async approve () {
                // if (this.selection === '0')
                //     this.$confirm({
                //         zIndex: 99999,
                //         title: 'Atenção',
                //         content: 'Você escolheu o perfil de administrador. Tem certeza que deseja prosseguir? Este perfil possui todos os acessos ao sistema.',
                //         okText : 'Confirmar',
                //         cancelText : 'Não',
                //         onOk: async () => {
                //             await this.answerRequest(true);
                //         },
                //     });
                // else
                await this.answerRequest(true);
            },
            async reprove () {
                await this.answerRequest(false);
            },
            async answerRequest (approved) {
                try {
                    this.busy = true;
                    const db = firebase.firestore();
                    const companyId = this.$store.getters.getCompanyID;
                    // Deal with concurrency
                    await db.collection(`company/${companyId}/invites`).doc(this.inviteId).update({
                        approved,
                        pending: false,
                        answeredAt: new Date()
                    });
                    if (approved)
                        await this.associateNewUser();
                    this.$emit('answered', approved);
                } finally {
                    this.busy = false;
                }
            },
            async associateNewUser () {
                const { value, requester } = this;
                try {
                    const companyId = this.$store.getters.getCompanyID;
                    await associateUserToCompany(companyId, requester, parseInt(value));
                } catch (err) {
                    console.log(err);
                    this.$store.commit('setError', err);
                }
                this.$success({
                    zIndex: 9999999,
                    title: 'Feito!',
                    content: `${requester.name} agora faz parte do time!`,
                    onOk: () => {
                        this.modalVisibility = true;
                    }
                })
            },
        },
    }
</script>

<style scoped>
  .icon-fix {
    top: 6px;
    position: relative;
    left: -4px;
  }
  .label-fix { 
    position: relative;
    top: -2px;
  }
  .increase-text {
    font-size: 14pt;
  }
</style>
